import { Injectable } from '@angular/core';

import { ConfigService } from 'src/app/core/core-config.service';
import { RequestService } from 'src/app/core/services/request.service';

import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { UserResponse } from '../models/user.model';
import { ClientResponse, ClientSecretResponse, ClientsResponse, CreateClientSecretRequest } from '../models/client.model';
import { IdentityResourceResponse } from '../models/identity-resource.model';
import { ApiResourceResponse } from '../models/api-resource.model';
import { CreateUser } from '../models/create-user.model';
import { CreateSiteInfoApiClientRequest } from '../models/create-siteinfo-api-client.model';



@Injectable()
export class ClientService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService) {
    }

    listClients(search: SimpleSearch):
        Promise<ClientsResponse> {

        let params = search.ToSearchParameters();

        let url =
            `${this.configService.config.apiBasePath}/clientManagement/listClients?${params.toString()}`;

        return this.requestService.get<ClientsResponse>(url);
    }

    createClient(craeteClient: CreateSiteInfoApiClientRequest): Promise<any> {

        let url =
            `${this.configService.config.apiBasePath}/clientManagement/createSiteInfoApiClient`;

        return this.requestService.post<any>(url, craeteClient);
    }

    enableClient(clientId: string): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/enable/${clientId}`;

        return this.requestService.post<any>(url, null);
    }

    disableClient(clientId: string): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/disable/${clientId}`;

        return this.requestService.post<any>(url, null);
    }

    deleteClient(clientId: string): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/delete`;

        return this.requestService.post<any>(url, null);
    }

    getClient(clientId: string): Promise<ClientResponse> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}`;

        return this.requestService.get<ClientResponse>(url);
    }

    addClientClaim(clientId: string, key: string, value: string): Promise<any> {
        let data = {
            key: key,
            value: value
        };

        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/claims`;

        return this.requestService.post<any>(url, data);
    }

    deleteClientClaim(clientId: string, claimId: number): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/claims/delete/${claimId}`;

        return this.requestService.post(url, null);
    }

    addClientAllowedScope(clientId: string, scope: string): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/allowedScopes/${scope}`;

        return this.requestService.post<any>(url, null);
    }

    deleteClientAllowedScope(clientId: string, scopeId: number): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/allowedScopes/delete/${scopeId}`;

        return this.requestService.post(url, null);
    }


    listClientSecrets(clientId: string):
        Promise<ClientSecretResponse> {

        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/secrets`;

        return this.requestService.get<ClientSecretResponse>(url);
    }

    addClientSecret(clientSecret: CreateClientSecretRequest): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/addClientSecret/`;

        return this.requestService.post<any>(url, clientSecret);
    }

    delteClientSecret(clientId: string, secretId: number): Promise<any> {
        let url =
            `${this.configService.config.apiBasePath}/clientManagement/clients/${clientId}/secrets/delete/${secretId}`;

        return this.requestService.post(url, null);
    }
}
